import { render } from "./UpdateSpecialPaymentRequestNoPO.vue?vue&type=template&id=3b31fcdd&scoped=true"
import script from "./UpdateSpecialPaymentRequestNoPO.vue?vue&type=script&lang=ts"
export * from "./UpdateSpecialPaymentRequestNoPO.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3b31fcdd"

export default script